var map = {
	"./auditlog.cattle.io.auditpolicy": 80824,
	"./auditlog.cattle.io.auditpolicy.vue": 80824,
	"./autoscaling.horizontalpodautoscaler": 36577,
	"./autoscaling.horizontalpodautoscaler/": 36577,
	"./autoscaling.horizontalpodautoscaler/index": 36577,
	"./autoscaling.horizontalpodautoscaler/index.vue": 36577,
	"./catalog.cattle.io.app": 78178,
	"./catalog.cattle.io.app.vue": 78178,
	"./catalog.cattle.io.clusterrepo": 21759,
	"./catalog.cattle.io.clusterrepo.vue": 21759,
	"./compliance.cattle.io.clusterscan": 71487,
	"./compliance.cattle.io.clusterscan.vue": 71487,
	"./configmap": 77482,
	"./configmap.vue": 77482,
	"./constraints.gatekeeper.sh.constraint": 49248,
	"./constraints.gatekeeper.sh.constraint.vue": 49248,
	"./fleet.cattle.io.bundle": 12199,
	"./fleet.cattle.io.bundle.vue": 12199,
	"./fleet.cattle.io.cluster": 96908,
	"./fleet.cattle.io.cluster.vue": 96908,
	"./fleet.cattle.io.clustergroup": 39133,
	"./fleet.cattle.io.clustergroup.vue": 39133,
	"./fleet.cattle.io.gitrepo": 52762,
	"./fleet.cattle.io.gitrepo.vue": 52762,
	"./fleet.cattle.io.helmop": 24271,
	"./fleet.cattle.io.helmop.vue": 24271,
	"./harvesterhci.io.management.cluster": 72236,
	"./harvesterhci.io.management.cluster.vue": 72236,
	"./helm.cattle.io.projecthelmchart": 52756,
	"./helm.cattle.io.projecthelmchart.vue": 52756,
	"./management.cattle.io.fleetworkspace": 1967,
	"./management.cattle.io.fleetworkspace.vue": 1967,
	"./management.cattle.io.globalrole": 4411,
	"./management.cattle.io.globalrole.vue": 4411,
	"./management.cattle.io.oidcclient": 82954,
	"./management.cattle.io.oidcclient.vue": 82954,
	"./management.cattle.io.roletemplate": 28655,
	"./management.cattle.io.roletemplate.vue": 28655,
	"./management.cattle.io.user": 12564,
	"./management.cattle.io.user.vue": 12564,
	"./namespace": 58271,
	"./namespace.vue": 58271,
	"./networking.k8s.io.ingress": 70857,
	"./networking.k8s.io.ingress.vue": 70857,
	"./node": 92071,
	"./node.vue": 92071,
	"./pod": 25058,
	"./pod.vue": 25058,
	"./projectsecret": 85075,
	"./projectsecret.vue": 85075,
	"./provisioning.cattle.io.cluster": 22837,
	"./provisioning.cattle.io.cluster.vue": 22837,
	"./rbac.authorization.k8s.io.clusterrole": 59191,
	"./rbac.authorization.k8s.io.clusterrole.vue": 59191,
	"./rbac.authorization.k8s.io.role": 41364,
	"./rbac.authorization.k8s.io.role.vue": 41364,
	"./secret": 63738,
	"./secret.vue": 63738,
	"./service": 31503,
	"./service.vue": 31503,
	"./workload": 8332,
	"./workload/": 8332,
	"./workload/index": 8332,
	"./workload/index.vue": 8332
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77031;
module.exports = webpackAsyncContext;